<template>
  <div>
    <v-row justify="center" align="center">
      <!-- {{ allAgencySubscriptions }} -->
      <v-col cols="12" sm="12" md="3" lg="3">
        <h2>All Subscriptions</h2>
        <!-- <v-btn @click="checkDemos()">demos</v-btn> -->
      </v-col>
      <v-col cols="5" class="pb-0 hidden-md-and-down">
        <v-select
          v-model="selectedFilter"
          :items="filterOptions"
          item-text="name"
          item-value="value"
          label="Filter by Status"
        ></v-select>
      </v-col>
      <v-col cols="2" class="text-right hidden-sm-and-down">
        <v-btn :disabled="demoCount >= 3" @click="createDemoReport()" class="primary" small rounded>Create Demo</v-btn>
      </v-col>
      <v-col cols="5" class="hidden-sm-and-up">
        <v-btn :disabled="demoCount >= 3" @click="createDemoReport()" class="primary" small rounded>Create Demo</v-btn>
      </v-col>
      <v-col cols="2" class="text-right hidden-sm-and-down">
        <createNewSubscription :selectPackage="selectPackage" />
        <!-- <v-btn class="primary" rounded small >Add Subscription</v-btn> -->
      </v-col>
      <v-col cols="7" class="hidden-sm-and-up">
        <createNewSubscription :selectPackage="selectPackage" />
        <!-- <v-btn class="primary" rounded small >Add Subscription</v-btn> -->
      </v-col>
      <v-col cols="12" class="pb-0 hidden-sm-and-up">
        <v-select
          v-model="selectedFilter"
          :items="filterOptions"
          item-text="name"
          item-value="value"
          label="Filter by Status"
        ></v-select>
      </v-col>
      <v-col v-if="!overlay" cols="12" class="px-0">
        <v-card v-if="filteredSubscriptions.length > 0" flat class="px-0">
          <v-row v-for="sub in displayedSubscriptions" :key="sub.uid">
            <v-col cols="12" sm="12" md="8" lg="8">
              <v-card>
                <v-card-text>
                  <v-row justify="center" align="center">
                    <v-col cols="8" sm="8" mb="6" lg="6" class="d-flex">
                      <h2 class="cardh2-dark">Plan:</h2>
                      <h2 class="cardh2-light">
                        {{ sub.package.currentPackage }}
                      </h2>
                    </v-col>
                    <v-col cols="4" sm="4" mb="4" lg="4" class="text-right pr-0">
                      <h1 class="cardh1">${{ sub.package.priceTotal }}</h1>
                    </v-col>
                    <v-col cols="6" sm="6" mb="2" lg="2" class="hidden-sm-and-down">
                      <h2 class="mt-2">/monthly</h2>
                    </v-col>
                    <v-col cols="12" sm="12" mb="6" lg="6" class="d-flex hidden-md-and-down">
                      <v-avatar class="mr-2">
                        <img :src="sub.package.pages[0].icon" alt="Page Icon" />
                      </v-avatar>
                      <h3 class="mt-3">
                        Primary Page: {{ sub.package.primaryPage.name }}
                      </h3>
                    </v-col>

                    <v-col cols="12" sm="12" mb="6" lg="6" class="text-right">
                      <v-btn
                        small
                        rounded
                        class="primary"
                        v-if="sub.paypalData?.status === 'ACTIVE' || sub.freeReport == true"
                        @click="viewSubscription(sub)"
                        >View Plan<v-icon
                          >mdi-arrow-right-bold-circle</v-icon
                        ></v-btn
                      >
                      <v-btn
                        small
                        rounded
                        class="primary"
                        v-if="sub.paypalData?.status === 'SUSPENDED'"
                        @click="viewPausedSubscription(sub)"
                        >View Plan<v-icon
                          >mdi-arrow-right-bold-circle</v-icon
                        ></v-btn
                      >
                      <v-btn
                        small
                        rounded
                        class="primary"
                        v-if="sub.paypalData?.status === 'CANCELLED'"
                        @click="viewCancelledSubscription(sub)"
                        >View Plan<v-icon
                          >mdi-arrow-right-bold-circle</v-icon
                        ></v-btn
                      >
                      <v-btn
                        small
                        rounded
                        class="primary"
                        v-if="sub.paypalData?.status === 'APPROVAL_PENDING'"
                        @click="viewSubscription(sub)"
                        >View Demo<v-icon
                          >mdi-arrow-right-bold-circle</v-icon
                        ></v-btn
                      >
                      <v-btn
                        small
                        rounded
                        class="primary"
                        v-if="!sub.paypalData && sub.freeReport != true"
                        @click="viewSubscription(sub)"
                        >View Demo<v-icon
                          >mdi-arrow-right-bold-circle</v-icon
                        ></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4" class="hidden-sm-and-down">
              <v-card :class="cardClass(sub)">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <h2 v-if="sub.paypalData?.status == 'ACTIVE' || sub.freeReport == true">
                        Next Payment Date
                      </h2>
                      <h2 v-if="sub.paypalData?.status == 'SUSPENDED'">
                        Payments On Hold From
                      </h2>
                      <h2 v-if="sub.paypalData?.status == 'CANCELLED'">
                        Payments Cancelled
                      </h2>
                      <h2 v-if="sub.paypalData?.status == 'APPROVAL_PENDING'">
                        Approval Pending
                      </h2>
                      <h2 v-if="!sub.paypalData && sub.freeReport != true">Demo Report Created on</h2>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                      <h1 v-if="sub.paypalData?.status == 'ACTIVE'">
                        On
                        {{
                          sub.paypalData.billing_info.next_billing_time
                            | formatDate
                        }}
                      </h1>
                      <h1 v-if="sub.paypalData?.status == 'SUSPENDED'">
                        {{ sub.paypalData.status_update_time | formatDate }}
                      </h1>
                      <h1 v-if="sub.paypalData?.status == 'CANCELLED'">
                        On {{ sub.paypalData.status_update_time | formatDate }}
                      </h1>
                      <h1 v-if="!sub.paypalData">
                        {{ sub.dateCreated | formatFirebaseDate }}
                      </h1>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="
                        sub.paypalData?.status == 'ACTIVE' ||
                        sub.paypalData?.status == 'SUSPENDED' ||
                        sub.paypalData?.status == 'CANCELLED' ||
                        sub.paypalData?.status == 'APPROVAL_PENDING' ||
                        sub.freeReport == true
                      "
                      class="pt-1"
                    >
                      <v-chip
                        small
                        v-if="sub.paypalData?.status == 'ACTIVE'"
                        class="green white--text"
                        >{{ sub.paypalData.status }}</v-chip
                      >
                      <v-chip
                        small
                        v-if="sub.freeReport == true"
                        class="green white--text"
                        >Active</v-chip
                      >
                      <v-chip
                        small
                        v-if="sub.paypalData?.status == 'SUSPENDED'"
                        class="warning white--text"
                        >PAUSED</v-chip
                      >
                      <v-chip
                        small
                        v-if="sub.paypalData?.status == 'CANCELLED'"
                        class="error white--text"
                        >{{ sub.paypalData.status }}</v-chip
                      > 
                      <!-- <v-chip
                        small
                        v-if="sub.paypalData?.status == 'APPROVAL_PENDING'"
                        class="primary white--text"
                        >{{ sub.paypalData.status }}</v-chip
                      > -->
                      <!-- <v-chip small v-if="!sub.paypalData" class="primary white--text">Days Left {{ sub.dateCreated | daysLeft }}</v-chip> <v-btn class="secondary" small rounded v-if="!sub.paypalData">Purchase<v-icon>mdi-arrow-right</v-icon></v-btn> -->
                    </v-col>
                    <v-col cols="6" v-if="!sub.paypalData && sub.freeReport != true || sub.paypalData?.status == 'APPROVAL_PENDING'">
                      <v-chip small class="primary white--text"
                        >{{ sub.dateCreated | daysLeft }}</v-chip
                      >
                    </v-col>
                    <v-col cols="6" v-if="!sub.paypalData  && sub.freeReport != true" class="text-right">
                      <v-btn
                        class="secondary"
                        small
                        rounded
                        @click="purcahseDemo(sub)"
                        v-if="!sub.paypalData"
                        >Purchase<v-icon>mdi-arrow-right</v-icon></v-btn
                      >
                    </v-col>
                    <v-col cols="6" v-if="sub.paypalData?.status == 'APPROVAL_PENDING'" class="text-right">
                      <v-btn
                        class="secondary"
                        small
                        rounded
                        @click="viewSubscription(sub)"
                        v-if="sub.paypalData?.status == 'APPROVAL_PENDING'"
                        >Purchase<v-icon>mdi-arrow-right</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="itemsToShow < filteredSubscriptions.length" justify="center">
            <!-- "See More" button -->
            <v-btn 
              @click="itemsToShow += increment" 
              rounded 
              small 
              class="primary mr-1"
            >
              See More
            </v-btn>
            <!-- "View Less" button -->
            <v-btn
              v-if="itemsToShow > increment"
              @click="itemsToShow -= increment"
              class="secondary ml-1"
              rounded 
              small
            >
              View Less
            </v-btn>
          </v-row>
        </v-card>
        <v-row v-else>
          <v-col cols="12" class="text-center pb-0">
            <v-divider class="mb-5"></v-divider>
            <p>You Have No Subscription Yet</p>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn @click="createDemoReport()" class="primary mr-3" small rounded >Create Demo</v-btn> <createNewSubscription :selectPackage="selectPackage"  />
          </v-col>
          <!-- <v-col cols="6" class="text-left">
            <createNewSubscription />
          </v-col> -->
        </v-row>
      </v-col>
      <v-col v-else>
        <v-skeleton-loader
          height="372px"
          class="mx-auto"
          type="table-heading, table-thead, table-tbody, table-tfoot"
        >
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { firebaseApp } from "../../firebaseConfig";
import {
  getFirestore,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
const db = getFirestore(firebaseApp);
import createNewSubscription from "../dialogs/createNewSubscription.vue";

import moment from "moment-timezone";

export default {
  props: ["allAgencySubscriptions", 'agency'],
  components: {
    createNewSubscription,
  },
  data: () => ({
    itemsToShow: 5, // Start by showing 5 items
    increment: 5,
    search: "",
    headers: [
      { text: "Client", value: "name", sortable: false, align: "center" },
      {
        text: "Company",
        sortable: false,
        value: "package.primaryPage.name",
        align: "center",
      },
      { text: "Package", sortable: false, value: "package", align: "center" },
      {
        text: "Date Created",
        value: "dateCreated",
        sortable: true,
        align: "center",
      },
      { text: "Status", value: "isActive", sortable: false, align: "center" },
      { text: "Action", value: "action", sortable: false, align: "center" },
    ],
    tableLoading: false,

    tab: null,
    overlay: false,
    selectedFilter: "All", // Default filter option
    filterOptions: [
      { name: "All", value: "All" },
      { name: "Active", value: "ACTIVE" },
      { name: "Paused", value: "SUSPENDED" },
      { name: "Cancelled", value: "CANCELLED" },
      { name: "Demos", value: "Demos" },
    ], // Filter options
    demoCount:0,

    selectPackage:[],
    selectPackageNoTrial: [
      { text: "Guardian Package", value: "package-1" },
      { text: "Spark Package", value: "package-2" },
      { text: "Pulse Package", value: "package-3" },
    ],
    selectPackageWithTrial: [
      { text: "Guardian Package Trial", value: "package-1-trial" },
      { text: "Spark Package Trial", value: "package-2-trial" },
      { text: "Pulse Package Trial", value: "package-3-trial" },
    ],
    hasPaidSubscription:false
  }),
  created() {
    // this.getPaypalData()
    let demosSubscriptions = []
    this.selectPackage = this.selectPackageWithTrial

    this.allAgencySubscriptions.forEach((item) => {
      console.log('item', item)
      if(item.package.packageType == 'Compeat Demo Subscription'){
        demosSubscriptions.push(item)
      }else {
        this.hasPaidSubscription = true
        this.selectPackage = this.selectPackageNoTrial
      }
    })

    this.demoCount = demosSubscriptions.length

    console.log(this.demoCount)
  },
  computed: {
    filteredSubscriptions() {
      // Filter subscriptions based on selected filter option
      if (this.selectedFilter === "All") {
        return this.allAgencySubscriptions;
      } else if (this.selectedFilter === "Demos") {
        return this.allAgencySubscriptions.filter((sub) => !sub.paypalData);
      } else {
        return this.allAgencySubscriptions.filter(
          (sub) => sub.paypalData?.status === this.selectedFilter.toUpperCase()
        );
      }
    },
    displayedSubscriptions() {
      return this.filteredSubscriptions.slice(0, this.itemsToShow);
  },
  },
  filters: {
    formatTotalAmount: function (value) {
      if (!value) return "";
      return new Intl.NumberFormat("en-ZA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("MMMM DD, YYYY");
      }
    },
    formatFirebaseDate(value) {
      if (value) {
        return moment(value).format("MMMM DD, YYYY");
      }
    },
    daysLeft(date) {
      // Convert milliseconds date to a Moment.js object
      const dateNew = moment(date);

      // Calculate the target date which is 7 days from the given date
      const targetDate = dateNew.clone().add(7, "days");

      // Calculate the difference in days between the target date and today's date
      const today = moment();
      const daysLeft = targetDate.diff(today, "days");

      if (daysLeft < 0) {
        return "Expired";
      } else {
        return daysLeft + " Days Left";
      }
    },
  },
  methods: {
    cardClass(sub) {
      if (sub.paypalData?.status === "ACTIVE" || sub.freeReport == true) {
        return "green lighten-4"; // Change to your desired class for active status
      } else if (sub.paypalData?.status === "SUSPENDED") {
        return "orange lighten-4"; // Change to your desired class for suspended status
      } else if (sub.paypalData?.status === "CANCELLED") {
        return "red lighten-4"; // Change to your desired class for cancelled status
      } else if (sub.paypalData?.status === "APPROVAL_PENDING") {
        return "secondary lighten-4"; // Change to your desired class for cancelled status
      } else if (!sub.paypalData) {
        return "blue lighten-4"; // Change to your desired class for demo subscriptions
      } else {
        return ""; // No additional class
      }
    },
    // getPaypalData() {
    //   this.overlay = true;
    //   const functions = getFunctions(firebaseApp, "europe-west2");
    //   const getPaypalSubscriptionNextPayment = httpsCallable(
    //     functions,
    //     "getPaypalSubscriptionNextPayment"
    //   );
    //   getPaypalSubscriptionNextPayment({
    //     subscriberId: this.$store.state.user.id,
    //   })
    //     .then((result) => {
    //       console.log("paypalSubscription", result.data.response);
    //       this.agencyActiveSubscriptions =
    //         result.data.response.subscriptionActivePaypalData;
    //       this.agencyInactiveSubscriptions =
    //         result.data.response.subscriptionCancelPaypalData;
    //       this.agencyPausedSubscriptions =
    //         result.data.response.subscriptionPausePaypalData;

    //       // Merge the arrays
    //       const mergedSubscriptions = this.agencyActiveSubscriptions.concat(
    //         this.agencyInactiveSubscriptions,
    //         this.agencyPausedSubscriptions
    //       );

    //       // If you want to ensure uniqueness in the merged array, you can use a Set
    //       const uniqueMergedSubscriptions = Array.from(
    //         new Set(mergedSubscriptions)
    //       );

    //       console.log(uniqueMergedSubscriptions);
    //       this.allAgencySubscriptions = uniqueMergedSubscriptions;

    //       this.overlay = false;
    //       // return result.data
    //     })
    //     .catch((err) => {
    //       this.overlay = false;
    //     });
    // },
    checkDemos() {
      this.overlay = true;
      const functions = getFunctions(firebaseApp, "europe-west2");
      const checkAllDemoReports = httpsCallable(
        functions,
        "checkAllDemoReports"
      );
      checkAllDemoReports()
        .then((result) => {
          console.log("demo subscriptions", result);
          // return result.data
        })
        .catch((err) => {
          this.overlay = false;
        });
    },
    //View the subscription
    viewSubscription(item) {
      this.$router.push({
        name: "singleSubscription",
        params: {
          id: this.$store.state.user.agencyId,
          uid: item.uid,
        },
      });
    },
    //View the paused subscription
    viewPausedSubscription(item) {
      this.$router.push({
        name: "singlePausedSubscription",
        params: {
          id: this.$store.state.user.agencyId,
          uid: item.uid,
        },
      });
    },
    //View the Cancelled subscription
    viewCancelledSubscription(item) {
      this.$router.push({
        name: "singleCancelledSubscription",
        params: {
          id: item.agencyId,
          uid: item.uid,
        },
      });
    },
    createDemoReport() {
      this.$router.push({
        name: "createSingleSubscription",
        params: {
          title: "package-demo",
        },
      });
    },
    purcahseDemo(sub) {
      // console.log('sub report id', sub.reportIds.competitiveReportIds[0].reportId)
      // console.log('sub uid', sub.uid)
      // console.log('this.agency.agencyId', this.agency.agencyId)
      this.$router.push({
        name: "singleReport",
        params: {
          id: this.agency.agencyId,
          uid: sub.uid,
          reportId: sub.reportIds.competitiveReportIds[0].reportId
        },
      });
    },
  },
};
</script>

<style>
.cardh2-dark {
  background: #3d6eb1;
  padding: 5px 10px;
  border-radius: 5px;
  color: white;
  margin-right: 5px;
  font-weight: bold;
}

.cardh2-light {
  padding: 5px 10px;
}

.cardh1 {
  font-size: 40px;
  /* color:#000000 */
}

.v-chip.v-size--small {
  border-radius: 15px;
  font-size: 13px;
  height: 30px;
}
</style>
